import { encode as encodeQueryParams } from './utils/query-params'
import { BACKEND_URL } from './utils/settings'
import { getBaseModel } from './utils/bike-schema'
import { Preset } from 'bike-schema'
import { BaseModelId } from 'shared'

const thumbnails = (
  el: HTMLElement,
  baseModelId: BaseModelId,
  size: string
): void => {
  const baseModel = getBaseModel(baseModelId)
  if (!baseModel) {
    throw new Error(`Base model '${baseModelId}' not found.`)
  }
  const html: string = baseModel.presets
    .map((preset: Preset) => {
      const query: string = encodeQueryParams({
        base_model_id: baseModelId,
        ...preset
      })
      const imageUrl: string = `${BACKEND_URL}/bike-image?size=${size}&${query}`
      const customizerUrl: string = `/customizer?${query}`
      return `<a href="${customizerUrl}"><img src="${imageUrl}"/></a>`
    })
    .join('')
  el.innerHTML = html
}

export default thumbnails
